<div class="jc-v3-cps-resume-wrap">
  <!-- Empty state -->
  <div class="jc-v3-cps-resume-empty" *ngIf="!hasResume">
    <ng-icon name="tablerFileText"></ng-icon>
    <h4>No resume uploaded</h4>
    <p>This candidate hasn't attached a resume yet.</p>
  </div>

  <!-- Resume file card — centered layout, mock parity
       (gigsumo_job_center_v2(16).html lines 1856-1862):
         large purple-light file icon on top
         → filename
         → uploaded date · file size
         → primary "Download Full Resume" button. -->
  <div class="jc-v3-cps-resume-card jc-v3-cps-resume-card--centered" *ngIf="hasResume">
    <ng-icon name="tablerFileDescription" class="jc-v3-cps-resume-bigicon"></ng-icon>
    <div class="jc-v3-cps-resume-name" [title]="filename">{{ filename }}</div>
    <div class="jc-v3-cps-resume-sub">
      <span *ngIf="uploadedOn">Uploaded {{ uploadedOn | date: 'd MMM y' }}</span>
      <span *ngIf="uploadedOn && fileSize" class="jc-v3-cps-resume-sep">·</span>
      <span *ngIf="fileSize">{{ fileSize }}</span>
    </div>
    <button type="button"
            class="jc-v3-cps-resume-dl"
            (click)="download()"
            [disabled]="downloading"
            [class.jc-v3-btn-downloading]="downloading">
      <ng-icon name="tablerDownload"></ng-icon>
      Download Full Resume
    </button>
  </div>
</div>
